import { assert_not_null } from '@shared/asserts/utils_asserts';

export function HOOK_CANVAS__static_mask() {
  function create_diagonal_pattern(ctx: CanvasRenderingContext2D): CanvasPattern {
    const pattern_canvas = document.createElement('canvas');

    const size = 32;

    pattern_canvas.width = size;
    pattern_canvas.height = size;

    const pattern_context = pattern_canvas.getContext('2d');
    assert_not_null(pattern_context);

    //
    // Entire tile starts transparent
    //
    pattern_context.clearRect(0, 0, size, size);

    //
    // Draw one red diagonal band.
    // Everything else remains transparent.
    //
    pattern_context.translate(size / 2, size / 2);
    pattern_context.rotate(-Math.PI / 4);

    pattern_context.fillStyle = 'rgba(255,0,0,1)';

    pattern_context.fillRect(-size, -1, size * 2, 2);

    const pattern = ctx.createPattern(pattern_canvas, 'repeat');
    assert_not_null(pattern);

    return pattern;
  }

  function render_static_mask(canvas_target: HTMLCanvasElement, image_mask_data: ImageData): void {
    const { width, height } = image_mask_data;

    canvas_target.width = width;
    canvas_target.height = height;

    const context = canvas_target.getContext('2d');
    assert_not_null(context);

    context.clearRect(0, 0, width, height);

    //
    // Build alpha-only mask canvas
    //
    const mask_canvas = document.createElement('canvas');

    mask_canvas.width = width;
    mask_canvas.height = height;

    const mask_context = mask_canvas.getContext('2d');
    assert_not_null(mask_context);

    const mask_image = mask_context.createImageData(width, height);

    const src = image_mask_data.data;
    const dst = mask_image.data;

    for (let i = 0; i < src.length; i += 4) {
      const brightness = (src[i] + src[i + 1] + src[i + 2]) / 3;

      const alpha = 255 - brightness;

      dst[i] = 255;
      dst[i + 1] = 255;
      dst[i + 2] = 255;
      dst[i + 3] = alpha;
    }

    mask_context.putImageData(mask_image, 0, 0);

    //
    // Draw stripes
    //
    context.fillStyle = create_diagonal_pattern(context);

    context.fillRect(0, 0, width, height);

    //
    // Clip stripes by mask
    //
    context.globalCompositeOperation = 'destination-in';

    context.drawImage(mask_canvas, 0, 0);

    context.globalCompositeOperation = 'source-over';
  }

  return {
    render_static_mask,
  };
}
